import * as React from 'react';
import {
    Typography,
    Grid,
    Collapse,
    Box,
    CircularProgress
} from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import Button from '@mui/material/Button';
import moment from "moment";
import { useMediaQuery } from "@mui/material";
import EjectIcon from '@mui/icons-material/Eject';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import { useDispatch } from 'react-redux';
import { setPage } from '../../redux/slices/userDataSlice';

const ApproveUser = ({ modalUsers ,hasNextPage,
    loading,
    }) => {


    const isMobile = useMediaQuery((theme) =>
        theme.breakpoints.between("sm", "md")
    );
    const dispatch = useDispatch();

    const [expanded, setExpanded] = React.useState(false);
    const handleToggle = (event, email) => {
        if (expanded === email) {
            setExpanded(null)
        }
        else {
            setExpanded(email)
        }
    }

    const [sentryRef] = useInfiniteScroll({
        loading: loading,
        hasNextPage: hasNextPage,
        onLoadMore: () => dispatch(setPage()),
        rootMargin: "400px 0px 0px 0px",
      });

    return (
        <div>
            <Grid container >
                {modalUsers?.map((user, index) => (
                    <Grid
                        item
                        xs={12}
                        md={11}
                        lg={11}
                        container
                       
                        sx={{
                            display: "flex",
                            borderRadius: "0.5rem",
                            bgcolor: "#FFFFFF",
                            border: "1px solid #B9D9EB",
                            width: isMobile ? "90%" : "40.875rem",
                            height: "fitContent",
                            ml: isMobile ? "1rem" : "2rem",
                            mt: "1.5625rem",
                            mr:"1.2rem",
                        }}
                    >
                        <Grid
                        width={"100%"}
                        >

                            <Grid item 
                                sx={{
                                    display: "flex",
                                    justifyContent: "space-between"
                                }}>
                                <Typography
                                    variant="h6"
                                    fontWeight={"600"}
                                    fontSize={"1.25rem"}
                                    lineHeight={"1.625rem"}
                                    color={"#000000"}
                                    mt={"1rem"}
                                    ml={"1rem"}
                                    // mb={"1rem"}
                                    sx={{ wordBreak: "break-word" }}
                                >
                                    {user.user_email}
                                </Typography>

                                <Button
                                    onClick={(event) => handleToggle(event, user.user_email)}
                                    sx={{
                                        width: "2rem",
                                        height: ".5rem",
                                        marginTop: "2.3125rem",
                                    }}><MoreVertIcon />

                                </Button>
                            </Grid>

                            <Typography
                                // variant="h6"
                                fontWeight={"400"}
                                fontSize={"0.875rem"}
                                lineHeight={"1.5rem"}
                                color={"#000000"}
                                ml={"1rem"}
                                mb={"1rem"}
                                sx={{ wordBreak: "break-all" }}
                                // pb={'30px'}
                            >
                                {user.company_name} | Approved on {user.approved_on && moment(
                                    user.approved_on).utc().format("MMM DD YYYY")}
                            </Typography>

                            <Collapse in={expanded === user.user_email}
                            style={{width:isMobile? "100%" : "40.79rem", mr:"1px",}}>
                                <Box ><span sx={{color:'1px solid red'}}><EjectIcon 
                                sx={{
                                color:'#F5F5F5',
                                width:'1.6rem',
                                height:'.856rem',
                                ml:isMobile? '88.5%' :'37.8875rem',
                                mb:'-0.6rem'}}/></span>
                                
                                <Grid item xs={12} md={12} lg={12}
                                    sx={{
                                        width: isMobile ? "100%" : "100%",
                                        height: "fitContent",
                                        border: "1px solid #B9D9EB",
                                        borderTopColor: "transparent",
                                        mr:"1.5rem",
                                        mt:'0rem',
                                        borderRadius: "0 0 0.5rem 0.5rem",
                                        bgcolor: "#F5F5F5",
                                        position: "relative",
                                        zIndex: "1234"

                                    }}
                                ><Typography sx={{
                                    mt: "1.5rem",
                                    ml: "1rem",
                                    font: "Open Sans",
                                    fontWeight: 400,
                                    fontSize: "0.875rem",
                                    lineHeight: "1.375rem",
                                    color: "#000000",
                                    wordBreak: "break-all"
                                }}>
                                        Approved by:
                                        <span sx={{
                                            font: "Open Sans",
                                            fontWeight: 600,
                                            fontSize: "0.875rem",
                                            lineHeight: "1.375rem",
                                            color: "#000000"
                                        }}> {user.approved_by} </span>
                                    </Typography>

                                    <Typography sx={{
                                        mt: "1.5rem",
                                        ml: "1rem",
                                        wordBreak: "break-all"
                                    }}>
                                        Requested by:<br></br>
                                        {user.user_email} on {user.requested_on && moment(
                                            user.requested_on).utc().format("MMM DD YYYY")}
                                    </Typography>
                                </Grid></Box></Collapse>

                        </Grid>
                        {modalUsers.length - 1 === index &&
                        modalUsers.length >= 12 &&
                        hasNextPage && (
                          <Box
                            ref={sentryRef}
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              py: "5rem",
                            }}
                          >
                            <CircularProgress />
                          </Box>
                        )
                    }
                    </Grid>
                ))}
                 {/* {!loading &&
            !isInput &&
            !modalUsers.length ? (
              <CircularProgress sx={{ m: "0 auto" }} />
            ) : null} */}
            </Grid>
        </div>
    )

}

export default React.memo(ApproveUser);